import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=2bd8ac6f&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=2bd8ac6f&prod&lang=scss&scoped=true"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=2bd8ac6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8ac6f",
  null
  
)

export default component.exports